<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>用户福利</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>

        <div class="page-content">
            <div style="display: flex; flex-flow: wrap;" class="input-view">
                <el-row @keyup.enter.native="loadData(1)">
                    <el-input v-model.trim="queryField.log_id" size="small" placeholder="id" v-if="false" />
                  <el-select v-model="queryField.game_id" placeholder="游戏名" @change="changeWelfareType">
                    <el-option
                        v-for="item in gameOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                    <el-select v-model="queryField.welfare_type" placeholder="福利类型" :disabled="WelfareTypeIsDisabled">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-model.trim="queryField.user_id" size="small" placeholder="用户id" />
                    <el-autocomplete
                        v-if="isSupper"
                        class="inline-input"
                        v-model="first"
                        :fetch-suggestions="querySearch"
                        value-key="nickName"
                        placeholder="一级渠道"
                        @select="handleSelect1"
                    ></el-autocomplete>
                    <el-autocomplete
                        v-if="isOneChannel"
                        class="inline-input"
                        value-key="nickName"
                        v-model="second"
                        :fetch-suggestions="querySearch2"
                        placeholder="二级渠道"
                        @select="handleSelect2"
                    ></el-autocomplete>
                    <el-date-picker
                        size="small"
                        v-model="queryField.start_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="开始日期">
                    </el-date-picker>
                    <el-date-picker
                        size="small"
                        v-model="queryField.end_time"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="结束日期">
                    </el-date-picker>
                    <el-button type="primary" size="small" style="height: 32px;" @click="loadData(1)">查询</el-button>
                    <el-button size="small" style="height: 32px;" @click="reset">重置</el-button>
                </el-row>
            </div>
            <div style="display: flex;width: 100%">
                <p class="grid-name">总金额(￥):{{ allAmount }}</p>
            </div>
            <el-table class="cps-table-data"
                :data="tableData" size="small"
                border v-loading="isLoading"
                :height="height"
                style="width: 100%">
                <el-table-column
                    v-if="false"
                    prop="log_id"
                    label="id"
                    width="90">
                </el-table-column>
                <el-table-column
                    prop="walfare_type"
                    :formatter="formatStatus"
                    label="福利类型"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="user_id"
                    label="用户id"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="user_name"
                    label="用户名"
                    width="120">
                </el-table-column>
              <el-table-column
                  prop="game_name"
                  label="游戏名称"
                  width="120">
              </el-table-column>
                <el-table-column
                    prop="add_time"
                    label="领取时间"
                    width="200">
                </el-table-column>
            </el-table>
            <el-pagination class="cps-table-data"
                           @current-change="loadData"
                           background
                           :page-size="15"
                           :current-page="currentIndex"
                           layout="total, prev, pager, next"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { queryHtWelfare,getHtWelfareCount,subChannelDropDown,channelDropDown } from '@/api/request'
export default {
    name: "UserWelfare",
    data(){
        return {
            allAmount: '',
            tableData:[],
            isLoading: false,
            isSupper: false,
            isOneChannel: false,
            WelfareTypeIsDisabled: true,
            queryField:{
                log_id: '',
                welfare_type: '',
                user_id: '',
                start_time: '',
                end_time: '',
                channel_first: '',
                channel_second: '',
                game_id: ''
            },
            gameOptions: [{
              value: '',
              label: '全部'
            },
              {
              value: 289,
              label: '鸿图归来'
            },
              {
                value: 309,
                label: '斗罗大陆武魂觉醒'
              }],
            options:[],
            first: '',
            second: '',
            height: window.innerHeight - 300,
            currentIndex: 1,
            total: 0,
            restaurants1: [],
            restaurants2: [],
        }
    },
    mounted() {
        this.queryField.game_id = 309;
        let user = JSON.parse(localStorage.getItem("userInfo"));
        this.isSupper = user.groupId === "1";
        this.isOneChannel = user.groupId === "1" || user.groupId === "22";
        
        this.changeWelfareType(this.queryField.game_id);
        this.loadData(1);
        this.loadAll1();
        this.loadAll2('0');
    },
    methods:{
        loadData(index){
            this.isLoading = true;
            if(this.queryField.start_time){
                this.queryField.start_time += " 00:00:00";
            }else {
                this.queryField.start_time = "";
            }
            if(this.queryField.end_time){
                this.queryField.end_time += " 23:59:59";
            }else {
                this.queryField.end_time = "";
            }

            let params = {
                pageNo: index,
                pageSize: 15,
                params:this.queryField
            }

            queryHtWelfare(params).then(res => {
                this.tableData = res.data.list;
                this.total = res.data.total;
                this.currentIndex = index;
                this.isLoading = false;
            })
            this.loadCount();
        },
        changeWelfareType(cellValue){
          if(cellValue == 289){
            this.WelfareTypeIsDisabled = false;
            this.options = [
              {
                value: 1,
                label: '周卡'
              },
              {
                value: 2,
                label: '月卡'
              }
            ]
          }else if(cellValue == 309){
            this.WelfareTypeIsDisabled = false;
            this.options = [
              {
                value: 1,
                label: '1天'
              },
              {
                value: 3,
                label: '3天'
              },
              {
                value: 5,
                label: '5天'
              },
              {
                value: 15,
                label: '15天'
              },
              {
                value: 30,
                label: '30天'
              }
            ]
          }else {
            this.WelfareTypeIsDisabled = true;
          }
        },
        loadCount(){
            getHtWelfareCount(this.queryField).then(res => {
                if(res.data.success){
                    this.allAmount = res.data.data;
                } else {
                    this.allAmount = '0';
                    this.$message.error(res.data.error.message);
                }
            })
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.nickName.indexOf(queryString.toLowerCase()) === 0)
            }
        },
        querySearch(queryString, cb) {
            let restaurants = this.restaurants1
            let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
            // 调用 callback 返回建议列表的数据
            cb(results)
        },
        querySearch2(queryString, cb) {
            let restaurants = this.restaurants2
            let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
            // 调用 callback 返回建议列表的数据
            cb(results)
        },
        handleSelect1(item) {
            this.queryField.channel_first = item.value
            if (item.value === '') {
                this.loadAll2('0')
            } else {
                this.loadAll2(item.value)
            }

        },
        handleSelect2(item) {
            this.queryField.channel_second = item.value
        },
        loadAll1() {
            let me = this
            channelDropDown().then(res => {
                me.restaurants1 = []
                let item1 = {}
                item1.value = ''
                item1.nickName = '全部'
                me.restaurants1.push(item1)
                res.data.data.forEach(function (e) {
                    if (!e.nick_name) {
                        e.nick_name = e.admin_id
                    }
                    let item = {}
                    item.value = e.admin_id
                    item.nickName = e.nick_name
                    me.restaurants1.push(item)
                })
            })
        },
        loadAll2(parentId) {
            let me = this
            subChannelDropDown(parentId).then(res => {
                me.restaurants2 = []
                let item1 = {}
                item1.value = ''
                item1.nickName = '全部'
                me.restaurants2.push(item1)
                let item2 = {}
                item2.value = '-1'
                item2.nickName = '一级自有'
                me.restaurants2.push(item2)
                res.data.data.forEach(function (e) {
                    if (!e.nick_name) {
                        e.nick_name = e.admin_id
                    }
                    let item = {}
                    item.value = e.admin_id
                    item.nickName = e.nick_name
                    me.restaurants2.push(item)
                })
            })
        },
        reset(){
            this.queryField = {
                log_id: '',
                welfare_type: '',
                user_id: '',
                start_time: '',
                end_time: '',
                channel_first: '',
                channel_second: '',
                game_id: 309
            }
            this.first = '';
            this.second = '';
            this.WelfareTypeIsDisabled = false;
            this.changeWelfareType(this.queryField.game_id);
            this.loadData(1);
        },
        formatStatus(row, column, cellValue){
          console.log(row.game_name);
          let rep = ''
          if(row.game_name === "鸿图归来"){
            if(cellValue === 1){
              rep = '周卡';
            }else if(cellValue === 2){
              rep = '月卡';
            }
          }else if(row.game_name === "斗罗大陆武魂觉醒"){
            if(cellValue === 1){
              rep = '1天';
            }else if(cellValue === 3){
              rep = '3天';
            }else if(cellValue === 5){
              rep = '5天';
            }else if(cellValue === 15){
              rep = '15天'
            }else if(cellValue === 30){
              rep = '30天'
            }
          }
          return rep;
        }
    }
}
</script>

<style scoped>

</style>